import React, { useState, useEffect } from "react";
import { Container, Grid, Autocomplete, TextField } from "@mui/material";
import "./styles.css";

export default function DbSearchApp() {
  const [data, setData] = useState([]);
  const [selectedThema, setSelectedThema] = useState("");
  const [selectedSchlagwort1, setSelectedSchlagwort1] = useState("");
  const [selectedSchlagwort2, setSelectedSchlagwort2] = useState("");
  const [filteredText, setFilteredText] = useState("");
  const [filteredImage, setFilteredImage] = useState("");
  const [imageExists, setImageExists] = useState(false);
  
  useEffect(() => {
    fetch("/mip4faq/api.php")
      .then((response) => response.json())
      .then((fetchedData) => {
        setData(fetchedData);
      });
  }, []);

	useEffect(() => {
	  fetch("/mip4faq/start_text.html?_=" + new Date().getTime())
		.then((response) => response.text())
		.then((htmlText) => {
		  console.log("📄 Eingelesener HTML-Text (aktuell):", htmlText);
		  setFilteredText(htmlText);
		})
		.catch((error) => {
		  console.error("Fehler beim Laden des HTML-Texts:", error);
		});
	}, []);

	useEffect(() => {
	  console.log("Aktuelle Daten:", data);
	  console.log("Auswahl - Thema:", selectedThema, "Schlagwort #1:", selectedSchlagwort1, "Schlagwort #2:", selectedSchlagwort2);

	  const hasSelected = selectedThema || selectedSchlagwort1 || selectedSchlagwort2;

	  const filteredRows = data.filter(
		(row) =>
		  row.thema?.trim() === selectedThema.trim() &&
		  row.schlagwort1?.trim() === selectedSchlagwort1.trim() &&
		  (!selectedSchlagwort2 || row.schlagwort2?.trim() === selectedSchlagwort2.trim())
	  );

	  console.log("Gefilterte Zeilen:", filteredRows);

	  if (filteredRows.length > 0) {
		setFilteredText(filteredRows[0].erlaeuterung);
		setFilteredImage(filteredRows[0].bildurl ? `/mip4faq/daten/${filteredRows[0].bildurl}` : "");
		checkImageExists(`/mip4faq/daten/${filteredRows[0].bildurl}`);
	  } else if (hasSelected) {
		// Nur zurücksetzen, wenn wirklich etwas ausgewählt wurde
		setFilteredText("");
		setFilteredImage("");
		setImageExists(false);
	  }
	}, [selectedThema, selectedSchlagwort1, selectedSchlagwort2, data]);

  const checkImageExists = (url) => {
    if (!url) {
      setImageExists(false);
      return;
    }
    const img = new Image();
    img.src = url;
    img.onload = () => setImageExists(true);
    img.onerror = () => setImageExists(false);
  };

  const uniqueValues = (key, filterKey = null, filterValue = null) => {
    let filteredData = data;
    if (filterKey && filterValue) {
      filteredData = data.filter((row) => row[filterKey]?.trim() === filterValue.trim());
    }
	return Array.from(
	  new Set(
		filteredData
		  .map((row) => row[key]?.trim())
		  .filter((val) => val && val.length > 0)
	  )
	);
  };

  const schlagwort1Options = uniqueValues("schlagwort1", "thema", selectedThema).sort();
  const schlagwort2Options = uniqueValues("schlagwort2", "schlagwort1", selectedSchlagwort1).sort();

  useEffect(() => {
    if (schlagwort2Options.length === 1) {
      setSelectedSchlagwort2(schlagwort2Options[0]);
    }
  }, [schlagwort2Options]);

const getOptionsOrFallback = (options) => {
  return options.length > 0 ? options : [{ label: "Keine Auswahl verfügbar", disabled: true }];
};

  return (
    <div style={{ backgroundColor: "#D9EEF5", minHeight: "100vh", padding: "20px" }}>
      <Container style={{ backgroundColor: "#FFFFFF", padding: "20px", borderRadius: "8px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h1>FöRiLi Kommentierungen: Schlagwortsuche</h1>
          <img src="/mip4faq/logo.png" alt="Logo" style={{ height: "50px" }} />
        </div>
        <Grid container spacing={2} marginTop={2}>
          <Grid item xs={4}>
            <Autocomplete
              freeSolo
              options={uniqueValues("thema").sort()}
              value={selectedThema}
              onInputChange={(event, newValue) => {
                setSelectedThema(newValue || "");
                setSelectedSchlagwort1("");
                setSelectedSchlagwort2("");
              }}
              renderInput={(params) => <TextField {...params} label="Thema" fullWidth />}
            />
          </Grid>
				<Grid item xs={4}>
				  <Autocomplete
					options={
					  schlagwort1Options.length > 0
						? schlagwort1Options
						: ["Keine Auswahl verfügbar"]
					}
					getOptionDisabled={(option) => option === "Keine Auswahl verfügbar"}
					value={
					  schlagwort1Options.includes(selectedSchlagwort1)
						? selectedSchlagwort1
						: ""
					}
					onChange={(event, newValue) => {
					  if (schlagwort1Options.includes(newValue)) {
						setSelectedSchlagwort1(newValue);
						setSelectedSchlagwort2(""); // wie bisher: bei neuer Auswahl #2 zurücksetzen
					  } else {
						setSelectedSchlagwort1("");
						setSelectedSchlagwort2("");
					  }
					}}
					renderInput={(params) => (
					  <TextField {...params} label="Schlagwort #1" fullWidth />
					)}
				  />
				</Grid>
			<Grid item xs={4}>
			  <Autocomplete
				options={
				  schlagwort2Options.length > 0
					? schlagwort2Options
					: ["Keine Auswahl verfügbar"]
				}
				getOptionDisabled={(option) => option === "Keine Auswahl verfügbar"}
				value={
				  schlagwort2Options.includes(selectedSchlagwort2)
					? selectedSchlagwort2
					: ""
				}
				onChange={(event, newValue) => {
				  if (schlagwort2Options.includes(newValue)) {
					setSelectedSchlagwort2(newValue);
				  } else {
					setSelectedSchlagwort2("");
				  }
				}}
				renderInput={(params) => (
				  <TextField {...params} label="Schlagwort #2" fullWidth />
				)}
			  />
			</Grid>
        </Grid>
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#FFFFFF",
            overflow: "hidden",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontSize: "13px",
            lineHeight: "1.42",
          }}
        >
          <div style={{ overflowX: "auto" }} dangerouslySetInnerHTML={{ __html: filteredText }}></div>
          {imageExists && <img src={filteredImage} alt="Erläuterung" style={{ maxWidth: "100%", marginTop: "10px", display: "block" }} />}
        </div>
      </Container>
    </div>
  );
}
